import { walkValue } from './Walk';

export interface SerializedSVGData {
    __type: 'svgData';
    __value: string;
}

export function isSerializedSVGData(x: unknown): x is SerializedSVGData {
    return (
        typeof x === 'object' &&
        x !== null &&
        '__type' in x &&
        '__value' in x &&
        x.__type === 'svgData' &&
        typeof x.__value === 'string'
    );
}

/**
 * Used by AdView components for change detection.
 */
export function stripSVGDataInPlace(previewData: unknown): void {
    walkValue(previewData, (_parent, _key, value) => {
        if (isSerializedSVGData(value)) {
            const pv: Partial<SerializedSVGData> = value;
            delete pv.__type;
            delete pv.__value;
            return false;
        }
        return true;
    });
}
